import { FaFacebook, FaTwitter, FaInstagram, FaAngleRight } from "react-icons/fa";
import { RiWhatsappFill } from "react-icons/ri";

import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <section className="bg-slate-200">
    <div className="mx-6 md:mx-20 lg:mx-40 block md:flex justify-between py-5">
      <div className="footer-info">
        <p className="font-bold">© 2023 Campus Closet.</p>
        <p> All rights reserved.</p>
        <p> Eldoret, Kenya 5912</p>
        <p>
          Email:{" "}
          <a href="https://mail.google.com/mail/?view=cm&to=youngprofessor991@gmail.com">
            info@campuscloset.com
          </a>
        </p>
        <p>Phone: +254-729-144-533</p>
        <p>Privacy Policy | <a href="/termsofuse">Terms of Use</a></p>
      </div>
      <div className="grid md:border-r md:pr-8 lg:pr-24  md:border-l mt-6 md:mt-0 md:pl-8 lg:pl-24  border-cyan-600">
        <h3 className="font-bold">Quick Links</h3>
        
        <Link to="/electronics">{"> Electronics"}</Link>
        <Link to="/households">{"> HouseHolds"}</Link>
        <Link to="/furniture">{"> Furniture"}</Link>
        <Link to="/others">{"> Others"}</Link>
        <Link to="/contacts">{"> Contact us"}</Link>
        <Link to="/about">{"> About us"}</Link>
      </div>
      <div className="footer-social my-10 md:mt-0">
        <p className="font-bold">Follow us on social media:</p>
        <ul className="flex space-x-3 mt-2">
          <li>
            <a href="https://www.facebook.com/@justoegitau">
              <FaFacebook size={26}/>
            </a>
          </li>
          <li>
            <a
              style={{ color: "black" }}
              href="https://www.twitter.com/@justoegitau"
              onMouseOver={(e) => (e.currentTarget.style.color = "blue")}
              onMouseOut={(e) => (e.currentTarget.style.color = "black")}
            >
              <FaTwitter size={26} />
            </a>
          </li>
          <li>
            <a
              style={{ color: "black" }}
              href="https://wa.me/254729144533"
              onMouseOver={(e) => (e.currentTarget.style.color = "#53CC60")}
              onMouseOut={(e) => (e.currentTarget.style.color = "black")}
            >
              <RiWhatsappFill size={26} />
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/justoegitau">
              <FaInstagram size={26} />
            </a>
          </li>
        </ul>
      </div>
      </div>
    </section>
  );
};

export default Footer;
